import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['downloadLink']

  connect() {
    if (this.hasDownloadLinkTarget) {
      this.downloadLinkTarget.click()
    }
    this.element.dataset.controller = ''
  }
}
